// Row component used by the mapping function in WeatherTable.js
import React from 'react';


function WeatherRow({wx}) {
    
    return (
  
            <tr>
                <td className='type-weather'>{wx.type}</td>
                <td className='weather-link' > <a href={`${wx.wx_link}`} target='_blank' rel="noopener noreferrer">{wx.wx_link}</a> </td>
                {/*<td className='weather-link' target='_blank'> <a href= {`${wx.wx_link}`} >xyz</a> </td>*/}
                {/*<td className='weather-link' target='_blank'> <a href="https://www.1800wxbrief.com">Weather Link</a> </td>*/}
                
            </tr> 
            
    );
} 

export default WeatherRow;
